import gridkyIcon from "../../images/gridky.svg";
import immoleadIcon from "../../images/immolead.png";

const OrigineIcon = ({ origin }) => {
  console.log(origin);
  if (!origin?.name) {
    return null;
  }
  return (
    <div
      title={
        origin.name?.toLowerCase()?.includes("immolead") ? "Immolead" : "Gridky"
      }
      className="position-relative border alignC"
      style={{
        borderRadius: "50%",
        backgroundColor: "#fff",
        width: "42px",
        height: "42px",
      }}
    >
      <img
        src={
          origin.name?.toLowerCase()?.includes("immolead")
            ? immoleadIcon
            : gridkyIcon
        }
        alt=""
        width="auto"
        height="28px"
      />
    </div>
  );
};

export default OrigineIcon;
